// import NavBar from "./Components/NavBar";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Home";
import ContactUs from "./Components/ContactUs";
import {Routes, Route} from 'react-router-dom';
import Careers from "./Components/Careers";
import Login from "./Components/Login";
import CollectKart from "./Components/CollectKart";
import CompanyPage from "./Components/Company";
import Test from "./Components/Test";
import DebtRecovery from "./Components/debt_recovery";
import Regtech from "./Components/RegTech";
import React from 'react';

import 'normalize.css';
import Container from "./Components/Testing";




function App() {
  return (
    <div>  
      {/* <NavBar/> */}
    <Header/>
    <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="/contactus" element={<ContactUs />}/>
      <Route path="/Careers" element={<Careers/>}/>
      <Route path="/Login" element={<Login/>}/>
      <Route path="/CollectKart" element={<CollectKart/>}/>
      <Route path="/CompanyPage" element={<CompanyPage/>}/>
      <Route path="/Test" element={<Test/>}/>
      <Route path="/DebtRecovery" element={<DebtRecovery/>}/>
      <Route path="/Regtech" element={<Regtech/>}/>
      <Route path="/Container" element={<Container/>}/>
    </Routes>
    <Footer/> 
    </div>
   
  );
}

export default App;
